import React from "react";
import Footer from "../utilities/Footer";
import AppState from "../../util/AppState";
import { useTranslation } from "react-i18next";
import successIcon from "../../resources/success-icon.svg";
import waitIcon from "../../resources/please-wait-icon.svg";
import errorIcon from "../../resources/error-icon.svg";
import { logFunctions as log } from "../../util/Logging";

function MessageScreen(props) {
  log.debug("+MessageScreen(TRACE)");

  const { t } = useTranslation("translation");

  const renderMessage = () => {
    log.debug("+MessageScreen_renderMessage(TRACE)");
    switch (props.message) {
      // Getting Ready Screen
      case AppState.GETTING_READY_SCREEN:
        log.info(
          "MessageScreen_renderMessage() => render: getting ready screen"
        );
        log.debug("-MessageScreen_renderMessage(TRACE)");
        return (
          <div className="messageTextBox" id="messageLabel">
            <img id="waitIcon" src={waitIcon} alt="waitIcon" />
            <p>{t("Please wait Your scanner is getting ready")}</p>
          </div>
        );
      // Successfully Released Device Screen
      case AppState.READY_SCREEN:
        log.info("MessageScreen_renderMessage() => render: ready screen");
        log.debug("-MessageScreen_renderMessage(TRACE)");
        return (
          <div className="messageTextBox" id="messageLabel">
            <img id="successIcon" src={successIcon} alt="successIcon" />
            <p>{t("You can now take the illuminated scanner")}</p>
          </div>
        );
      // Error Releasing Device Screen
      case AppState.ERROR_SCREEN:
        log.info("MessageScreen_renderMessage() => render: error screen");
        log.debug("-MessageScreen_renderMessage(TRACE)");
        return (
          <div className="messageTextBox" id="messageLabel">
            <img id="errorIcon" src={errorIcon} alt="errorIcon" />
            <p>{t("An error has occurred! Returning you to scan screen")}</p>
          </div>
        );
      // Invalid ID Screen
      case AppState.PROFILE_NOT_FOUND_SCREEN:
        log.info(
          "MessageScreen_renderMessage() => render: profile not found screen"
        );
        log.debug("-MessageScreen_renderMessage(TRACE)");
        return (
          <div className="messageTextBox" id="messageLabel">
            <img id="errorIcon" src={errorIcon} alt="errorIcon" />
            <p>{t("Invalid ID Please try again")}</p>
          </div>
        );
      // Error Staging Screen
      case AppState.ERROR_STAGING_SCREEN:
        log.info(
          "MessageScreen_renderMessage() => render: error staging screen"
        );
        log.debug("-MessageScreen_renderMessage(TRACE)");
        return (
          <div className="messageTextBox" id="messageLabel">
            <img id="errorIcon" src={errorIcon} alt="errorIcon" />
            <p>{t("Something went wrong")}</p>
            <div
              className="messageScreenButton"
              id="startOverButton"
              onClick={() => {
                localStorage.removeItem("StyleSheetURL");
                localStorage.removeItem("SupportedLocales");
                localStorage.removeItem("SharedKey");
                localStorage.removeItem("SecretKey");
                localStorage.removeItem("orgID");
                props.transitionToStagingScreen();
              }}
            >
              <p>{t("Start over")}</p>
            </div>
          </div>
        );
      // NO devices available screen
      case AppState.NO_DEVICES_AVAILABLE_SCREEN:
        log.info(
          "MessageScreen_renderMessage() => render: error no devices available"
        );
        log.debug("-MessageScreen_renderMessage(TRACE)");
        return (
          <div className="messageTextBox" id="messageLabel">
            <img id="errorIcon" src={errorIcon} alt="errorIcon" />
            <p>{t("No devices available")}</p>
          </div>
        );
      // Device already taken screen
      case AppState.DEVICE_ALREADY_TAKEN_SCREEN:
        log.info(
          "MessageScreen_renderMessage() => render: error device has already been checked out to this customer"
        );
        log.debug("-MessageScreen_renderMessage(TRACE)");
        return (
          <div className="messageTextBox" id="messageLabel">
            <img id="errorIcon" src={errorIcon} alt="errorIcon" />
            <p>{t("Device has already been checked out to this customer")}</p>
          </div>
        );
      // Success loading location and profile
      case AppState.CONFIGURATION_SUCCESS:
        log.info(
          "MessageScreen_renderMessage() => render: configuration success"
        );
        log.debug("-MessageScreen_renderMessage(TRACE)");
        return (
          <div className="messageTextBox" id="messageLabel">
            <img id="successIcon" src={successIcon} alt="successIcon" />
            <p>{t("Your scannerwall is now ready to use!")}</p>
          </div>
        );
      // Welcome Screen
      case AppState.WELCOME_SCREEN:
        log.info("MessageScreen_renderMessage() => render: welcome screen");
        log.debug("-MessageScreen_renderMessage(TRACE)");
        return (
          <div className="messageTextBox" id="messageLabel">
            <p id="welcomeScreenTextLabel">
              {t("Thank you for purchasing from NCR")}
            </p>
            <div
              className="messageScreenButton"
              id="startButton"
              onClick={() => {
                props.transitionToStagingScreen();
              }}
            >
              <p>{t("Let's get started")}</p>
            </div>
          </div>
        );
      case AppState.WEB_SOCKET_CONNECTION_ERROR_SCREEN:
        log.info(
          "MessageScreen_renderMessage() => render: websocket connection error screen"
        );
        log.debug("-MessageScreen_renderMessage(TRACE)");
        return (
          <div className="messageTextBox" id="messageLabel">
            <img id="errorIcon" src={errorIcon} alt="errorIcon" />
            <p>
              {t(
                "Server connectivity lost Trying to reestablish connectivity!"
              )}
            </p>
          </div>
        );
      // Default Error Screen
      default:
        log.info(
          "MessageScreen_renderMessage() => render: default error screen"
        );
        log.debug("-MessageScreen_renderMessage(TRACE)");
        return (
          <div className="messageTextBox" id="messageLabel">
            <img id="errorIcon" src={errorIcon} alt="errorIcon" />
            <p>{t("An error has occurred! Returning you to scan screen")}</p>
          </div>
        );
    }
  };

  log.debug("-MessageScreen(TRACE)");
  return (
    <div className="Screen">
      <div className="contentContainer">{renderMessage()}</div>
      <div className="footerContainer" id="footer">
        <Footer
          transitionToSelectLanguageScreen={
            props.transitionToSelectLanguageScreen
          }
          state={AppState.MESSAGE_SCREEN}
        />
      </div>
    </div>
  );
}

export default MessageScreen;
